/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonRelayInfo,
    JsonRelayInfoFromJSON,
    JsonRelayInfoFromJSONTyped,
    JsonRelayInfoToJSON,
} from './JsonRelayInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonRelayInfo
 */
export interface ApiResultOfJsonRelayInfo {
    /**
     * 
     * @type {JsonRelayInfo}
     * @memberof ApiResultOfJsonRelayInfo
     */
    data?: JsonRelayInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonRelayInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonRelayInfo
     */
    result?: ApiResultOfJsonRelayInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonRelayInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonRelayInfoFromJSON(json: any): ApiResultOfJsonRelayInfo {
    return ApiResultOfJsonRelayInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonRelayInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonRelayInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonRelayInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonRelayInfoToJSON(value?: ApiResultOfJsonRelayInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonRelayInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

